import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@mui/material";

export default function AssignmentEditDialog({ open, shop, loading, onClose, onSubmit }) {
  const [form, setForm] = useState({
    is_active: true,
    is_primary: true,
    connection_role: "shared",
    notes: "",
  });

  useEffect(() => {
    if (!open || !shop) return;
    setForm({
      is_active: shop.pivot?.is_active ?? true,
      is_primary: shop.pivot?.is_primary ?? true,
      connection_role: shop.pivot?.connection_role || "shared",
      notes: shop.pivot?.notes || "",
    });
  }, [open, shop]);

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit shop assignment</DialogTitle>
      <DialogContent dividers sx={{ display: "grid", gap: 2 }}>
        <FormControl fullWidth>
          <InputLabel>Connection role</InputLabel>
          <Select
            value={form.connection_role}
            label="Connection role"
            onChange={(event) => setForm((current) => ({ ...current, connection_role: event.target.value }))}
          >
            <MenuItem value="primary">Primary</MenuItem>
            <MenuItem value="secondary">Secondary</MenuItem>
            <MenuItem value="backup">Backup</MenuItem>
            <MenuItem value="shared">Shared</MenuItem>
          </Select>
        </FormControl>
        <FormControlLabel
          control={<Switch checked={form.is_primary} onChange={(event) => setForm((current) => ({ ...current, is_primary: event.target.checked }))} />}
          label="Primary assignment"
        />
        <FormControlLabel
          control={<Switch checked={form.is_active} onChange={(event) => setForm((current) => ({ ...current, is_active: event.target.checked }))} />}
          label="Assignment is active"
        />
        <TextField
          fullWidth
          multiline
          minRows={3}
          label="Assignment notes"
          value={form.notes}
          onChange={(event) => setForm((current) => ({ ...current, notes: event.target.value }))}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button variant="contained" onClick={() => onSubmit(form)} disabled={loading}>
          {loading ? "Saving..." : "Save assignment"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
